import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import AuthWrapper from './common/AuthWrapper';
import InputWrapper from '../common/InputWrapper';
import ErrorBlock from '../common/ErrorBlock';
import Button from '../common/Button';

import { fetchForgot } from '../../actions/auth';

import { preventSubmittingByEnter, parseError } from '../../helpers';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const validationSchema = Yup.object().shape({
  email: Yup.string().trim().required('Необходимое поле').email('Невалидный email'),
});

const ForgotPage = (props) => {
  const dispatch = useDispatch();
  const forgot = useSelector((state) => state.auth.forgot);
  const [loading, setLoading] = useState(false);

  const { t } = useAutoTranslation();

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    onSubmit: async (values) => {
      setLoading(true);
      const { email } = values;
      await dispatch(fetchForgot({ email }))
        .then(() => {
          toast.info(t('Мы выслали письмо с дальнейшими инструкциями на вашу почту'));
        })
        .finally(() => {
          setLoading(false);
        });
    },
    validationSchema,
  });

  const { values, errors, submitCount, handleChange, handleSubmit, setFieldValue } = formik;

  return (
    <AuthWrapper>
      <div style={{ textAlign: 'center', marginBottom: '25px' }}>
        <h4>{t('Забыли пароль?')}</h4>
        <p>{t('Введите ваш email, и мы отправим письмо с инструкциями по восстановлению')}:</p>
      </div>
      <form onKeyDown={preventSubmittingByEnter} onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <InputWrapper
            type="text"
            label={t('Email')}
            id="email"
            value={values.email.trim()}
            error={errors.email}
            showValidation={submitCount}
            onChange={handleChange}
            placeholder={t('Введите email')}
            testId="forgotPageEmailInput"
          />
        </div>

        {forgot.error && <ErrorBlock error={forgot.error} />}

        <div className="form-group mb-0 text-center">
          <Button
            type="submit"
            text={t('Отправить')}
            loading={loading}
            disabled={loading}
            style={{ width: '100%' }}
          />
        </div>
      </form>

      <div className="text-center" style={{ marginTop: '15px' }}>
        <p>
          <Link to="/sign_in" className="ml-1">
            {t('Войти')}
          </Link>
        </p>
        <p className="text-50">
          {t('Нет аккаунта?')}{' '}
          <Link to="/sign_up" className="ml-1">
            {t('Регистрация')}
          </Link>
        </p>
      </div>
    </AuthWrapper>
  );
};

export default ForgotPage;
